import { type Field, useFormApi } from '@data-driven-forms/react-form-renderer';

import Flex from '~/common/components/Flex';

type FlexBoxProps = React.ComponentProps<typeof Flex> & {
  fields?: Field[];
};

export default function FlexBox({
  flexDirection = 'column',
  alignItems,
  justifyContent,
  padding,
  margin,
  className,
  fields = [],
  ...rest
}: Readonly<FlexBoxProps>) {
  const { renderForm } = useFormApi();
  return (
    <Flex
      {...rest}
      flexDirection={flexDirection}
      alignItems={alignItems}
      justifyContent={justifyContent}
      padding={padding}
      margin={margin}
      className={className}
    >
      {renderForm(fields)}
    </Flex>
  );
}
